import axios from "../../config/axiosConfig";
import { CREATE_PRODUCTION, GET_PRODUCTIONS, PRODUCTION_REQUEST, UPDATE_PRODUCTION, DELETE_PRODUCTION, PRODUCTION_REQUEST_FAILURE, GET_PRODUCTION_PAGE, PRODUCTION_REQUEST_SUCCESS } from "../types";

export const getProductionsWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Book_Id,Account_Id,Quality',
      };
      return axios.get("/production/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PRODUCTION_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getProductions = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id, companyId: auth.company?.id };
      if (include) {
        params = { ...params, include };
      }
      // if (!auth?.company?.Common_Company) {
      //   params = { ...params, companyId: auth.company?.id }
      // }
      return axios.get("/production/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PRODUCTIONS, payload: response.data?.data || [] });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getProductionById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_REQUEST });
      return axios.get(`/production/get/${id}`).then((response) => {
        dispatch({ type: PRODUCTION_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getAllTwistOptionsInProduction = () => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
      };
      return axios.get(`/production/get-all-twist-options-in-production`, { params }).then((response) => {
        if (response.data) {
          return response.data;
        } else {
          return [];
        }
      }).catch((error) => {
        dispatch({ type: PRODUCTION_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getAllGstLotDescCheckedByPackedByOptionsInProduction = (includeLotDesc) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        includeLotDesc: includeLotDesc
      };
      return axios.get(`/production/get-all-gst-lot-desc-checkedby-packedby-opt`, { params }).then((response) => {
        if (response.data) {
          return response.data;
        } else {
          return [];
        }
      }).catch((error) => {
        dispatch({ type: PRODUCTION_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getValidatedIncrementedTakaNoProductionEntry = (otherparams) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      if(otherparams) {
        params = { ...params, ...otherparams };
      }
      const response = await axios.get("/production/get-next-taka-number", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const isTakaNoExitsInProduction = (otherparams) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      if(otherparams) {
        params = { ...params, ...otherparams };
      }
      const response = await axios.get("/production/is-taka-no-exist", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const createProduction = (production) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: PRODUCTION_REQUEST });
      return axios.post("/production/add", production,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_PRODUCTION, payload: response.data });
        } else {
          dispatch({
            type: PRODUCTION_REQUEST_FAILURE,
            error: "Production create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateProduction = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_REQUEST });
      const { auth } = getState();
      return axios.put("/production/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }
      }).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_PRODUCTION,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: PRODUCTION_REQUEST_FAILURE,
            error: "Production code update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteProduction = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_REQUEST });
      const { auth } = getState();
      return axios.delete(`/production/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_PRODUCTION, id: id });
          const include = ['id', 'Vch_No', 'Book_Id', 'Date', 'Account_Id', 'Quality'].join(',');
          const searchCols = ['Vch_No', 'Book_Id', 'Date', 'Account_Id', 'Quality', 'totalWeight', 'totalMeter', 'totalTaka'].join(',');
          const { page, pageSize, searchStr, where,  } = getState()?.inventory?.production || {};
          dispatch(getProductionsWithPagination(page, pageSize, include, searchStr, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PRODUCTION_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PRODUCTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};